import moment from 'moment';
import { ReactNode } from 'react';
import { AuditLog, Changes } from '../../../types/auditLogs';
import LogInfo from '../../AuditLogComps/LogInfo';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ShowLogDetailsModal = ({
  handleModalClose,
  auditLog,
}: {
  handleModalClose: () => void;
  auditLog: AuditLog;
}) => {
  // destructuring the audit log object here
  const { changes, perform_by_full_name, timestamp, action } = auditLog || {};

  console.log('LOG CHANGES: ', auditLog);

  const generateLogInfo = (changes: Changes): Array<ReactNode> => {
    const logInfoArr: Array<ReactNode> = [];

    console.log('AUDIT LOG CHANGES: ', changes);

    const prevData = changes.data_before;
    const newData = changes.data_after;

    for (const key in prevData) {
      logInfoArr.push(
        <LogInfo
          key={key}
          title={key.split('_').join(' ')}
          prevValue={key === 'password' ? '' : prevData[key]}
          currentValue={
            action === 'update'
              ? key === 'password'
                ? 'Modified'
                : newData[key]
              : null
          }
        />
      );
    }

    return logInfoArr;
  };

  // rendering show log details modal component here
  return (
    <ParentModal onClick={handleModalClose} customWidthClass='md:w-[700px]'>
      <ModalTitle titleText='log details' />

      <div className='border-2 border-dashed border-legal-dark-blue px-3 py-2 rounded-lg'>
        {generateLogInfo(JSON.parse(changes) as Changes)}
      </div>

      <p className='text-xs text-center md:text-right text-base-dark-blue'>
        {action === 'update' ? 'Updated' : 'Deleted'} by{' '}
        <span className='font-medium text-base-purple'>
          {perform_by_full_name}
        </span>{' '}
        on{' '}
        <span className='font-medium text-base-purple'>
          {moment(timestamp).format('DD-MM-YYYY')}
        </span>{' '}
        at{' '}
        <span className='font-medium text-base-purple'>
          {moment(timestamp).format('hh:mm A')}
        </span>
      </p>
    </ParentModal>
  );
};

export default ShowLogDetailsModal;
